import { CAlert } from "@coreui/react";
import { useQuery } from "@tanstack/react-query";
import React, { useState } from "react";
import ReactApexChart from "react-apexcharts";
import { useHttp } from "../hooks/useHttp";
import LoadingCenter from "./LoadingCenter";

const ChartHours = props => {
  const { user } = props;

  const request = useHttp();
  const { data: chartData, isLoading } = useQuery(["access", user], () => request({ url: `/users/access/${user}`, method: "GET" }));

  const [state] = useState({
    series: [{
      name: "Quantidade de vezes em que logou",
      data: chartData?.data
    }],
    options: {
      chart: {
        type: "bar",
        height: 350,
        toolbar: {
          show: false,
        }
      },
      plotOptions: {
        bar: {
          color: "#F97F0C",
          borderRadius: 1,
          horizontal: true,
          dataLabels: {
            position: "top", // top, center, bottom
          },
        }
      },
      fill: {
        colors: ["#F97F0C"]
      },
      dataLabels: {
        enabled: false
      },
      xaxis: {
        categories: ["00:00", "01:00", "02:00", "03:00", "04:00", "05:00", "06:00", "07:00", "08:00", "09:00", "10:00", "11:00", "12:00", "13:00", "14:00", "15:00", "16:00", "17:00", "18:00", "19:00", "20:00", "21:00", "22:00", "23:00", "23:59"],
      },
      title: {
        text: "Horários em que o usuário mais loga",
        floating: true,
        align: "center",
        offsetY: -5,
        style: {
          fontSize: "16px",
          fontWeight: "500",
          fontFamily: "Segoe UI, sans-serif",
          color: "#263238"
        },
      }
    }
  });

  if (isLoading) return <LoadingCenter />;

  if (chartData?.data.error) {
    return (
      <CAlert color="warning">
        {chartData?.data.message}
      </CAlert>
    );
  }

  return (
    <div className="box x-p-10 pt-15 z-index-top">
      <ReactApexChart options={state.options} series={state.series} type="bar" height={600} />
    </div>
  );
}

export default ChartHours;